
import './sobreNosotros.css';

const SobreNosotros = () => {
    return (
        <div className='backgroudContainer'>
            <div className='container rounded-lg shadow-lg w-4/6 md:w-4/12'>
                <h1 className='title font-bold md:text-2xl' >CONOCE TODO SOBRE NOSOTROS</h1>
                <p className='text-white md:text-lg pr-2'>
                    Proteínas y Oleicos, somos una empresa dedicada a la comercialización de aceites comestibles,
                    grasas vegetales y mixtas.
                </p>
            </div>
        </div>
    )
}


export default SobreNosotros;